// src/platform/integration/types.ts
var PlatformIntegrationAriResourceOwner = "platform", PlatformIntegrationAriResourceType = "integration";

export {
  PlatformIntegrationAriResourceOwner,
  PlatformIntegrationAriResourceType
};
